import React from "react";
import { Link } from "react-router-dom";
import Header from "../common/Header/header.jsx";
import Footer from "../common/Footer/footer.jsx";
import { MdEmail } from "react-icons/md";
import { MdPhone } from "react-icons/md";
import "./contact.css";

const ContactPage = () => {
  const facultyDetails = [
    { label: "", value: "Assistant Professor" },
    { label: "Specialization", value: "Hydraulics Engineering" },
    { label: "Room No", value: "217-A" },
  ];
  const contactInformation = [
    { label: <MdEmail />, value: "abhishek@ce.iitr.ac.in" },
    { label: <MdPhone />, value: "(O) 91-1332-285180 (R) 91-1332-284480" },
    { label: <MdPhone />, value: "(M) 9897674598" },
  ];

  return (
    <>
      <Header />
      <div className="contact-page-background">
        <h1 className="name">ABHISHEK</h1>
        <div className="abhishek-img"></div>
        <div className="abhishek-info">
          <div className="faculty-detail">
            {facultyDetails.map((detail, index) => (
              <div key={index} className="faculty-detail-item">
                {detail.label
                  ? `${detail.label}: ${detail.value}`
                  : `${detail.value}`}
              </div>
            ))}
          </div>
          <div className="contacts">
            {contactInformation.map((info, index) => (
              <div key={index} className="contact-item">
                <div className="contact-icon">{info.label}</div>
                <div>{info.value}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="get-in-touch">Join The Lab</div>
        <div className="join-the-lab my-2">
          <div>
            <h3 className="join-section-title">PhD</h3>
            <h5 className="join-section-subtitle">
              Join Our Centre for a PhD in Engineering
            </h5>
            <p className="join-section-description">
              You must fulfil all the requirements to be considered as a
              potential candidate. Please go through the admissions portal
              carefully.
            </p>
            <Link
              className="portal-link"
              to="https://iitr.ac.in/Academics/static/Admission/PhD/Rolling/Rolling_Info._Brochure_2023.pdf"
              target="_main"
            >
              TO THE PORTAL
            </Link>
          </div>
          <hr />
          <div>
            <h3 className="join-section-title">Postdoc</h3>
            <h5 className="join-section-subtitle">
              National Post Doctoral Fellowship (N-PDF)
            </h5>
            <p className="join-section-description">
              The SERB-National Post Doctoral Fellowship (N-PDF) is aimed to
              identify motivated young researchers and provide them support for
              doing research in frontier areas of science and engineering. The
              fellows will work under a mentor, and it is hoped that this
              training will provide them a platform to develop as an independent
              researcher.
            </p>
            <Link
              className="portal-link"
              to="https://serbonline.in/SERB/npdf"
              target="_main"
            >
              TO THE PORTAL
            </Link>
          </div>
          <hr />
          <div>
            <h3 className="join-section-title">Project position</h3>
            <p className="join-section-description">
              There are no positions available at this moment. We will update
              this section as soon as a position is available.
            </p>
          </div>
        </div>
        <div className="contact-message ">
          Feel free to drop a message below or reach out via email to connect. I
          look forward to hearing from you and exploring potential
          collaborations.
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
